<template>
    <div class="barHolder">
        <div class="barFill" :style="{'width':currentBarWidth}" :class="{'paused':pause}"></div>
    </div>
</template>

<script>
export default {
    data: function () {
        return {
            duration: 10000,        // ms -> 5 seconds,
            currentBarWidth: null,
        }
    },
    props: {
        pause: {
            type: Boolean,
            defaul: false
        }
    },
    created: function () {
        this.animateBar('decrease')
    },
    methods: {
        animateBar: function (animation) {
            var width = (animation == 'decrease')? 100 : 0
            var id = setInterval(frame, this.duration / 100);
            var vm = this;

            function frame() {
                if(vm.pause){
                    return  false;
                }

                if(animation == 'decrease'){
                    if (width <= 0) {
                        clearInterval(id);
                        vm.animationCompleted()
                    } else {
                        width--;
                        vm.currentBarWidth = width + '%'
                    }
                } else {
                    if (width > 100) {
                        clearInterval(id);
                        vm.animationCompleted()
                    } else {
                        width++;
                        vm.currentBarWidth = width + '%'
                    }
                }
            }
        },
        animationCompleted: function () {
            this.$emit('done')
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/_variables.scss';

.barHolder{
    width: 100%;
    height: 4px;
    border-radius: 999px;
    overflow: hidden;
    margin-bottom: 0 !important;

    .barFill{
        border-radius: 999px;
        background: $blue-bright;
        // width: 75%;
        height: 100%;
        transition: all ease-in-out 50ms;

        &.paused{
            background-color: $medium
        }
    }
}
</style>



// WEBPACK FOOTER //
// timedBar.vue?3b64481f